import {
  AuthenticationIdpType,
  AuthMeDto,
  AuthMeResponse,
  AuthUserData,
  ParsedTokenModel,
} from './auth-user-data.model';
import { ListViewMode } from '../../monitoring/constants/list-view-mode.constant';

type AuthUserDataCtorInput = ParsedTokenModel & { permissions: AuthMeDto['permissions'] };

function normalizeAuthenticationIdp(value: string): AuthenticationIdpType | undefined {
  if (!value) {
    return undefined;
  }

  const values = Object.values(AuthenticationIdpType) as string[];
  return values.includes(value) ? (value as AuthenticationIdpType) : undefined;
}

function normalizeLoadTOMode(value: string): ListViewMode | undefined {
  const values = Object.values(ListViewMode) as string[];
  return values.includes(value) ? (value as ListViewMode) : undefined;
}

export function mapMeDtoToAuthMeResponse(dto: AuthMeDto): AuthMeResponse {
  const ctorInput: AuthUserDataCtorInput = {
    country: dto.country,
    twentyFourHourTime: dto.twentyFourHourTime,
    defaultLanguage: dto.defaultLanguage,
    dpnAccepted: dto.dpnAccepted,
    email: dto.email,
    emailConfirmed: dto.emailConfirmed,
    exp: 0,
    iat: 0,
    isInternalUser: dto.isInternalUser,
    id: dto.id,
    newsSubscribed: dto.newsSubscribed,
    passwordExpired: dto.passwordExpired,
    plantIds: dto.plantIds,

    roles: dto.roles as unknown as ParsedTokenModel['roles'],
    user: dto.user as unknown as ParsedTokenModel['user'],

    isFirstLogin: dto.isFirstLogin,
    authenticationIdp: normalizeAuthenticationIdp(dto.authenticationIdp),
    isMaterialView: dto.isMaterialView,
    addDeliveryDateColumn: dto.addDeliveryDateColumn,
    loadTOMode: normalizeLoadTOMode(dto.loadToMode),

    permissions: dto.permissions,
  };

  const userData = new AuthUserData(ctorInput);

  return Object.assign(userData, { expiresAt: dto.expiresAt ?? null });
}
